import { Card, CardContent } from '@components/card';
import { EditMerchantUserForm } from '@components/forms/merchantUsers/edit';
import { Loader } from '@components/loader';
import { useEditMerchantUserForm } from '@hooks/forms/merchantUsers/editForm';
import { BaseLayout } from '@layouts/base';
import { useGetMerchantUser } from '@services/merchant/users/get';
import { useUpdateUser } from '@services/merchant/users/update';
import { createFileRoute, redirect, useNavigate, useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

function EditMerchantUser() {
  const { t } = useTranslation('app');
  const { id, localId } = useParams({ from: '/u/$localId/_merchant/merchant/users/$id/edit' });
  const navigate = useNavigate();
  const { data, isPending } = useGetMerchantUser(id);

  const requestHandler = useUpdateUser({
    id,
    callback: () => {
      toast.success(t('toast.users.updateSuccess'));
      navigate({
        to: '/u/$localId/merchant/users/$id',
        params: { id, localId: localId || '0' },
        replace: true,
      }).catch((err) => {
        console.error(err);
      });
    },
  });

  const formObj = useEditMerchantUserForm({ user: data, requestHandler });

  if (isPending) return <Loader />;
  if (!data) return null;

  return (
    <BaseLayout isChild title={t('pages.editMerchantUser.title')}>
      <Card>
        <CardContent className="p-6">
          <EditMerchantUserForm formObj={formObj} />
        </CardContent>
      </Card>
    </BaseLayout>
  );
}
export const Route = createFileRoute('/u/$localId/_merchant/merchant/users/$id/edit')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['merchant_users_read', 'merchant_users_update'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: EditMerchantUser,
});
